<!-- 7. LENGUAJES Y HERRAMIENTAS -->
<div class="tech-section" id="tecnologias">
  <h2 class="section-title2">Lenguajes y Herramientas</h2>
  
  <div class="tech-categories">
    <div class="tech-category" *ngFor="let category of techCategories">
      <h3>{{ category.name }}</h3>
      
      <div class="tech-icons">
        <div class="tech-icon" 
             *ngFor="let tech of category.technologies; let i = index"
             [style.animation-delay]="i * 0.1 + 's'">
          <i [class]="tech.icon" [style.color]="tech.color"></i>
          <span>{{ tech.name }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
